module.exports = __webpack_public_path__ + "img/map.ecdb538f.svg";